import { gql } from '@apollo/client';
import performQuery from './contentfulClient';

export interface PrivacyNotice {
  sys: {
    id: string;
  };
  title: string;
  messageText: {
    json: any;
  };
}

export const PRIVACY_NOTICE_QUERY = gql`
  query PrivacyNoticeQuery($entryId: String!) {
    ansMessaging(id: $entryId) {
      sys {
        id
      }
      title
      messageText {
        json
      }
    }
  }
`;

export const usePrivacyNoticeQuery = async (entryId: string) => {
  const response = await performQuery(PRIVACY_NOTICE_QUERY, { entryId });

  if (response.hasError) {
    return {
      data: null,
      error: true,
      errorMsg: response.error,
    };
  }

  return {
    data: response.res?.data?.ansMessaging as PrivacyNotice | null,
    error: false,
  };
};

export const CERTIFY_REPORTING_PERSON_QUERY = gql`
  query CertifyReportingPersonQuery($entryId: String!) {
    ansMessaging(id: $entryId) {
      sys {
        id
      }
      title
      messageText {
        json
      }
    }
  }
`;

export const useCertifyReportingPerson = async (entryId: string) => {
  const response = await performQuery(CERTIFY_REPORTING_PERSON_QUERY, { entryId });

  if (response.hasError) {
    return {
      data: null,
      error: true,
      errorMsg: response.error,
    };
  }

  return {
    data: response.res?.data?.ansMessaging as PrivacyNotice | null,
    error: false,
  };
};
